/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1Coupon200,
  GetApiV1Coupon401,
  GetApiV1Coupon500,
  GetApiV1CouponQueryParams,
  GetApiV1CouponQueryResponse,
} from "../../types/couponRegistroController/GetApiV1Coupon.ts";
import { couponListItemViewModelPaginatedResponseSchema } from "../couponListItemViewModelPaginatedResponseSchema.ts";

export const getApiV1CouponQueryParamsSchema = z.object({
  filter: z.optional(z.string()),
  page: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(20),
}) as unknown as ToZod<GetApiV1CouponQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1Coupon200Schema = z.lazy(
  () => couponListItemViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1Coupon200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1Coupon401Schema =
  z.any() as unknown as ToZod<GetApiV1Coupon401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1Coupon500Schema =
  z.any() as unknown as ToZod<GetApiV1Coupon500>;

export const getApiV1CouponQueryResponseSchema = z.lazy(
  () => getApiV1Coupon200Schema,
) as unknown as ToZod<GetApiV1CouponQueryResponse>;
